import React, { useState, useEffect } from 'react';
import { Ticket } from '../../../../entities/ticket';
import { getTickets } from '../../../../entities/ticket/api/ticketApi';
import * as S from '../ExternalDataTabs.styles';

interface TournamentTicketsTabProps {
  ticket: Ticket;
}

export const TournamentTicketsTab: React.FC<TournamentTicketsTabProps> = ({ ticket }) => {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTickets = async () => {
      try {
        setLoading(true);
        const clientTickets = await getTickets({
          site: 'tournament',
          clientId: ticket.client.id,
          orderBy: 'updated_desc',
          limit: 200,
        });
        setTickets(clientTickets);
      } catch (error) {
        console.error('Ошибка загрузки истории тикетов:', error);
      } finally {
        setLoading(false);
      }
    };

    if (ticket.client.id) {
      loadTickets();
    }
  }, [ticket.client.id]);

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  const getStatusLabel = (status: string) => {
    const labels: Record<string, string> = {
      new: 'Новый',
      active: 'Открыт',
      waiting_info: 'Ожидание ответа',
      resolved: 'Решен',
      closed: 'Закрыт',
      spam: 'Спам',
      duplicate: 'Дубликат',
    };
    return labels[status] || status;
  };

  const getPriorityLabel = (priority: string) => {
    const labels: Record<string, string> = {
      low: 'Низкий',
      medium: 'Средний',
      high: 'Высокий',
      urgent: 'Срочный',
    };
    return labels[priority] || priority;
  };

  if (loading) {
    return <S.EmptyState>Загрузка...</S.EmptyState>;
  }

  if (tickets.length === 0) {
    return <S.EmptyState>Нет других обращений</S.EmptyState>;
  }

  return (
    <div>
      <S.SectionTitle>История обращений ({tickets.length})</S.SectionTitle>
      {tickets.map((t) => (
        <S.ListItem key={t.id}>
          <S.ListItemTitle>
            {t.id === ticket.id ? 'Текущий тикет' : t.title}
          </S.ListItemTitle>
          <S.InfoRow>
            <S.InfoLabel>Статус</S.InfoLabel>
            <S.InfoValue>
              <S.Badge $variant={t.status === 'resolved' || t.status === 'closed' ? 'success' : 'info'}>
                {getStatusLabel(t.status)}
              </S.Badge>
            </S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Приоритет</S.InfoLabel>
            <S.InfoValue>{getPriorityLabel(t.priority)}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Создан</S.InfoLabel>
            <S.InfoValue>{formatDate(t.createdAt)}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Обновлен</S.InfoLabel>
            <S.InfoValue>{formatDate(t.updatedAt)}</S.InfoValue>
          </S.InfoRow>
        </S.ListItem>
      ))}
    </div>
  );
};
